module.exports = __webpack_public_path__ + "img/ps-educacion.38841718.jpg";